import type { CustomField } from './helpers'
import { config as positionConfig } from './position'
import { config as distributionConfig } from './distribution'
import { config as candidateConfig } from './candidate'

export type { CustomField } from './helpers'

export type ReportBuilderModel = 'position' | 'distribution' | 'candidate'

export interface ModelFieldConfig {
  fields: CustomField[]
  requiredFields: string[]
  requiredFieldObjects: CustomField[]
}

export const MODEL_CONFIG: Record<ReportBuilderModel, ModelFieldConfig> = {
  position: positionConfig,
  distribution: distributionConfig,
  candidate: candidateConfig
}
